/// <amd-module name="VSSUI/SplitButton" />

export { SplitButton } from "./Components/SplitButton/SplitButton";
export { ISplitButtonProps } from "./Components/SplitButton/SplitButton.Props";
